import React from 'react';
import { IImageDownloaderProps } from './models';

const ImageDownloader: React.FC<IImageDownloaderProps> = ({
  linkName,
  imgWithLink,
  downloadURL,
  showLabel = true,
}) => {
  const handleOpenLink = () => {
    if (downloadURL) {
      window.open(downloadURL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      {imgWithLink?.image?.url && (
        <button
          type="button"
          onClick={handleOpenLink}
          className="img-btn"
          aria-label={imgWithLink?.imageAlt}
        >
          <img src={imgWithLink.image.url} alt={imgWithLink.imageAlt || ''} />
        </button>
      )}
      {showLabel && linkName && (
        <button type="button" onClick={handleOpenLink} className="img-btn">
          {linkName}
        </button>
      )}
    </>
  );
};

export default ImageDownloader;
